import {Loader, Empty, CheckCircleIcon} from 'common/components'
import {Notification} from '.'

interface UpdatesProps {
  completed?: boolean
  isCategoryReading?: boolean
  notifications: any[]
}

export default function Updates({
  completed,
  isCategoryReading,
  notifications,
}: UpdatesProps) {
  if (completed && !notifications) return <Loader />

  if (completed && notifications.length === 0)
    return (
      <Empty
        icon={<CheckCircleIcon width={40} height={40} />}
        title="completed updates"
      />
    )

  return (
    <ul>
      {notifications.map((notification) => (
        <Notification
          key={notification.uuid}
          isCategoryReading={isCategoryReading}
          notification={notification}
        />
      ))}
    </ul>
  )
}
